import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import { object, string, number, date } from "yup";

let editValidateSchema = object({
  pincode: string()
    .notRequired()
    .matches(/^\d{6}$/, "Pincode must be 6 digits"),
  home_pincode: string()
    .notRequired()
    .matches(/^\d{6}$/, "Pincode must be 6 digits"),
  office_pincode: string()
    .notRequired()
    .matches(/^\d{6}$/, "Pincode must be 6 digits"),
  dob: date(),
});

export function MyDetails() {
  // const [userData, setuserData] = useState();

  const formik = useFormik({
    initialValues: {
      user_id: localStorage.getItem("user_id"),
      // user_type: "USER",
      full_name: "",
      // email: "",
      // phone_number: "",
      // user_password: "",
      // active_flag: "",
      dob: "",
      pincode: "",
      city: "",
      home_street: "",
      home_city: "",
      home_state: "",
      home_pincode: "",
      office_street: "",
      office_city: "",
      office_state: "",
      office_pincode: "",
      // updated_time: "",
      // created_time: ""
    },
    validationSchema: editValidateSchema,
    onSubmit: async (values) => {
      try {
        const formattedValues = {
          ...values,
          dob: values.dob
            ? new Date(values.dob).toISOString().split("T")[0]
            : null,
          home_pincode: values.home_pincode
            ? Number(values.home_pincode)
            : null,
          office_pincode: values.office_pincode
            ? Number(values.office_pincode)
            : null,
          pincode: values.pincode ? Number(values.pincode) : null,
        };
        const response = await axiosInstance.put(
          "/updateUserDetails",
          formattedValues
        );
        if (response.status === 200) {
          toast.success(response.message || "Updated Successfully!");
          LoadUsers();
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });

  async function LoadUsers() {
    try {
      const response = await axiosInstance.get("/getUserDetails");
      const activeUsers = response.data.data.filter(
        (item) => item.active_flag === "A"
      );

      if (activeUsers.length) {
        const {
          full_name = "",
          city = "",
          dob = "",
          pincode = "",
          home_street = "",
          home_city = "",
          home_state = "",
          home_pincode = "",
          office_street = "",
          office_city = "",
          office_state = "",
          office_pincode = "",
          email = "",
          phone_number = "",
        } = activeUsers[0];

        // Format DOB to 'YYYY-MM-DD'
        const formattedDob = dob
          ? new Date(dob).toISOString().split("T")[0]
          : "";

        formik.setValues({
          ...formik.values,
          full_name,
          city,
          dob: formattedDob,
          pincode,
          home_street,
          home_city,
          home_state,
          home_pincode,
          office_street,
          office_city,
          office_state,
          office_pincode,
          email,
          phone_number,
        });
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  useEffect(() => {
    LoadUsers();
  }, []);

  
  return (
    <>
      <ToastContainer />
      <div className="detailsContainer">
        <form onSubmit={formik.handleSubmit}>
          <div>
            {/* {userData && (
             
            )} */}
            <div>
              {/* personal details */}
              <div className="person-container">
                <div className="personal-title">Personal Details</div>

                <div className="personal-subcontainer">
                  <div className="personal-left">
                    <div className="personal-field">
                      <label for="full_name">Full Name</label>
                      <div>
                        <input
                          type="text"
                          id="full_name"
                          onChange={formik.handleChange}
                          // value={userData[0]?.full_name}
                          value={formik.values.full_name}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="phone_number">Phone Number</label>
                      <div style={{ cursor: "not-allowed" }}>
                        <input
                          disabled
                          type="text"
                          id="phone_number"
                          value={formik.values.phone_number}
                          // value={
                          //   userData[0]?.phone_number
                          //     ? userData[0].phone_number
                          //     : "--"
                          // }
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="city">City</label>
                      <div>
                        <input
                          type="text"
                          id="city"
                          onChange={formik.handleChange}
                          value={formik.values.city}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="personal-right">
                    <div className="personal-field">
                      <label for="dob">Date of Birth</label>
                      <div>
                        <input
                          type="date"
                          id="dob"
                          onChange={formik.handleChange}
                          value={formik.values.dob}
                        />
                      </div>
                    </div>

                    <div className="personal-field">
                      <label for="email">Email Address</label>
                      <div style={{ cursor: "not-allowed" }}>
                        <input
                          disabled
                          type="email"
                          id="email"
                          // value={
                          //   userData[0]?.email ? userData[0].email : "--"
                          // }
                          value={formik.values.email}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="pincode">Pin Code</label>
                      <div>
                        <input
                          type="text"
                          id="pincode"
                          onChange={formik.handleChange}
                          value={formik.values.pincode}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.pincode && formik.touched.pincode && (
                          <div className="text-danger">
                            {formik.errors.pincode}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* address */}
              <div className="person-container">
                <div className="personal-title">My Addresses</div>
                <div className="homeText">
                  <span>Home</span>
                  <span>
                    <FaRegEdit />
                  </span>
                </div>
                <div className="personal-subcontainer">
                  <div className="personal-left">
                    <div className="personal-field">
                      <label for="home_street">Street</label>
                      <div>
                        <input
                          type="text"
                          id="home_street"
                          onChange={formik.handleChange}
                          value={formik.values.home_street}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="home_state">State</label>
                      <div>
                        <input
                          type="text"
                          id="home_state"
                          onChange={formik.handleChange}
                          value={formik.values.home_state}
                        />
                        {/* <select>
                        <option value={
                          userData[0]?.home_state? userData[0].home_state : "--"
                        }>Telangane</option>
                      </select> */}
                        {/* <select >
                        <option value="Telangana">Telangana</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="--">--</option>{" "}
                     
                      </select> */}
                      </div>
                    </div>
                  </div>
                  <div className="personal-right">
                    <div className="personal-field">
                      <label for="home_city">City</label>
                      <div>
                        <input
                          type="text"
                          id="home_city"
                          onChange={formik.handleChange}
                          value={formik.values.home_city}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="home_pincode">Pin Code</label>
                      <div>
                        <input
                          type="text"
                          id="home_pincode"
                          onChange={formik.handleChange}
                          value={formik.values.home_pincode}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.home_pincode &&
                          formik.touched.home_pincode && (
                            <div className="text-danger">
                              {formik.errors.home_pincode}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="homeText">
                  <span>Office</span>
                  <span>
                    <FaRegEdit />
                  </span>
                </div>
                <div className="personal-subcontainer">
                  <div className="personal-left">
                    <div className="personal-field">
                      <label for="office_street">Street</label>
                      <div>
                        <input
                          type="text"
                          id="office_street"
                          onChange={formik.handleChange}
                          value={formik.values.office_street}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="office_state ">State</label>
                      <div>
                        <input
                          type="text"
                          id="office_state"
                          onChange={formik.handleChange}
                          value={formik.values.office_state}
                        />
                        {/* <select>
                        <option value="Telangana">Telangana</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="--">--</option>{" "}
                      
                      </select> */}
                      </div>
                    </div>
                  </div>
                  <div className="personal-right">
                    <div className="personal-field">
                      <label for="office_city">City</label>
                      <div>
                        <input
                          type="text"
                          id="office_city"
                          onChange={formik.handleChange}
                          value={formik.values.office_city}
                        />
                      </div>
                    </div>
                    <div className="personal-field">
                      <label for="office_pincode">Pin Code</label>
                      <div>
                        <input
                          type="text"
                          id="office_pincode"
                          onChange={formik.handleChange}
                          value={formik.values.office_pincode}
                          onBlur={formik.handleBlur}
                        />

                        {formik.errors.office_pincode &&
                          formik.touched.office_pincode && (
                            <div className="text-danger">
                              {formik.errors.office_pincode}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* button container */}
          <div className="btnDetailsSave">
            <button type="submit">Save Changes</button>
          </div>
        </form>
      </div>
    </>
  );
}
